import { Injectable, inject } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observable, delay, of } from 'rxjs'
import { ConnectionService } from '@agroone-front/shared'

@Injectable()
export class OfflineInterceptor implements HttpInterceptor {
  private connectionService = inject(ConnectionService)

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.connectionService.connected && request.method !== 'GET') {
      const offlineResponse: HttpResponse<null> = new HttpResponse({
        status: 0,
        body: null,
      })
      return of(offlineResponse).pipe(delay(1000))
    }

    return next.handle(request)
  }
}
